import { render } from "./PerformanceGraph.vue?vue&type=template&id=6c052723&scoped=true"
import script from "./PerformanceGraph.vue?vue&type=script&lang=js"
export * from "./PerformanceGraph.vue?vue&type=script&lang=js"

import "./PerformanceGraph.vue?vue&type=style&index=0&id=6c052723&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c052723"]])

export default __exports__
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QSpinner});
